import { ButtonGroup, PrimaryButton } from "@digipost/dds-buttons-react";
import { Heading } from "@digipost/dds-heading-react";
import { FC, useEffect } from "react";
import { useSelector } from "react-redux";

import { RegistrationStatus } from "../infrastructure/redux/org/org-actions";
import { ReduxState } from "../infrastructure/redux/state";
import {
  callbackUrlIntegrasjon,
  isBehandlerFlow,
} from "../infrastructure/stateAccessors";
import Translated from "../infrastructure/Translated";
import { useRootPath } from "../infrastructure/useRootPath";
import { useTranslate } from "../infrastructure/useTranslate";
import RegisterFlowStepper from "../registrer/RegisterFlowStepper";
import styles from "./BehandlerFlowConfirmation.module.css";
import mannMedNettbrett from "./mann_med_nettbrett.svg";

const BehandlerFlowConfirmation: FC = () => {
  const translate = useTranslate();
  const rootPath = useRootPath();
  const behandlerFlow = useSelector((state: ReduxState) =>
    isBehandlerFlow(state),
  );
  const registrationStatus = useSelector(
    (state: ReduxState) => state.org.registrationStatus,
  );
  const existing = useSelector((state: ReduxState) => !!state.org.existing);
  const partnerName = useSelector(
    (state: ReduxState) => state.org.userInput.selectedIntegrationPartner?.name,
  );
  const digipostAddress = useSelector(
    (state: ReduxState) => state.org.digipostaddress,
  );
  const callbackUrl = useSelector(callbackUrlIntegrasjon);

  useEffect(() => {
    // Guard for tilfeldig navigering
    if (!behandlerFlow && registrationStatus !== RegistrationStatus.COMPLETE) {
      window.location.href = `${rootPath}/bedrift`;
    }
  }, [behandlerFlow, registrationStatus]);

  return (
    <main>
      <Heading level={1} size="large">
        {existing ? (
          <Translated
            textKey="confirm.partner.exists.title"
            params={{ partnerName }}
          />
        ) : (
          <Translated textKey="confirm.partner.title" />
        )}
      </Heading>

      <RegisterFlowStepper currentStep="COMPLETE" />

      <div className={styles.contentWrapper}>
        <div>
          <p>
            <Translated
              textKey={
                existing
                  ? "confirm.partner.exists.description"
                  : "confirm.partner.description"
              }
              params={{ partnerName }}
              allowHtml={true}
            />
          </p>

          {digipostAddress && (
            <p>
              <Translated
                textKey="confirm.partner.digipostaddress"
                params={{ address: digipostAddress }}
                allowHtml={true}
              />
            </p>
          )}

          <ButtonGroup>
            <PrimaryButton as="a" href={callbackUrl || ""}>
              <Translated
                textKey="register.org.complete_partner"
                params={{ partnername: partnerName }}
              />
            </PrimaryButton>
          </ButtonGroup>
        </div>
        <img
          className={styles.illustration}
          src={mannMedNettbrett}
          alt={translate("confirm.man_with_tablet")}
        />
      </div>
    </main>
  );
};

export default BehandlerFlowConfirmation;
